import React, { Component } from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {push, replace} from 'react-router-redux';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

class PC extends Component {

  state = {
    tabIndex: 0
  }


  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps){
  }

  componentWillUnmount(){
  }

  render = () => {
    const { onDismiss } = this.props;
    return <div className='submit_tips_container'>
      <div className='submit_tips_content'>
        <div className='submit_tips_title'>Submitted Project Security Detection</div>
        <div className='holder'>
          <div className='flex_row' style={{ marginTop: '.6rem' }}>
            <img alt='' className='submit_tips_icon' src={require('../assets/1.png')}></img>
            <div>
              <div className='submit_tips_text1'>Free Security Detection</div>
              <div className='submit_tips_text2'>{`All projects submitted for detecting will go through at least 18 security detect items in 3 categories！`}</div>
            </div>
          </div>
          <div className='flex_row' style={{ marginTop: '.6rem' }}>
            <img alt='' className='submit_tips_icon' src={require('../assets/2.png')}></img>
            <div>
              <div className='submit_tips_text1'>Least 18 security detection items</div>
              <div className='submit_tips_text2'>{`Transcation Security
Token  Security
Team Info  Security`}</div>
            </div>
          </div>
          <div className='flex_row' style={{ marginTop: '.6rem' }}>
            <img alt='' className='submit_tips_icon' src={require('../assets/3.png')}></img>
            <div>
              <div className='submit_tips_text1'>All results are disclosed to the user</div>
              <div className='submit_tips_text2'>{`Just, fair and open`}</div>
            </div>
          </div>
        </div>
        <div className='submit_tips_confirm' onClick={onDismiss}>OK</div>
        <div className='submit_tips_close' onClick={onDismiss}></div>
      </div>
    </div>
  }
}

export default connect(mapStateToProps, mapActionCreators)(injectIntl(PC));
